import { useContext } from 'react';

import AppInfoContext from 'bundles/page/contexts/AppInfoContext';

const useUserAgent = () => {
  return useContext(AppInfoContext).userAgent;
};

export default useUserAgent;
